import { stringifyUrl } from 'query-string';
import { THIRD_PARTY_AUTH_SERVICE } from 'api/constants';
import { getEnv } from 'config';
import { SOCIAL_AUTH_PATH } from './constants';
import { GetSocialAuthStatusRequest, SocialPlatform } from './types';

export function createGetAuthStatusUrl({
  provider,
  scopeContext,
  forceLogin,
}: GetSocialAuthStatusRequest) {
  const baseUrl = getEnv(THIRD_PARTY_AUTH_SERVICE);
  return stringifyUrl({
    url: `${baseUrl}${SOCIAL_AUTH_PATH}/me`,
    query: { provider, scopeContext, forceLogin: String(!!forceLogin) },
  });
}

export function createApiAuthUrl(platform: SocialPlatform) {
  const baseUrl = getEnv(THIRD_PARTY_AUTH_SERVICE);
  return `${baseUrl}${SOCIAL_AUTH_PATH}/${platform}/login`;
}
